// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import investigationEvidenceEntity from './entities/investigation-evidence.json';
import investigationEvidenceMenu from '../pages/investigation-evidence/menu.json';
import investigationEvidenceFullForm from '../pages/investigation-evidence/forms/full.json';
import investigationEvidenceContextForm from '../pages/investigation-evidence/forms/context.json';
import investigationEvidenceMiniForm from '../pages/investigation-evidence/forms/mini.json';
import investigationEvidenceLookupForm from '../pages/investigation-evidence/forms/lookup.json';
import investigationEvidenceTableView from '../pages/investigation-evidence/views/table.json';
import investigationEvidenceCardsView from '../pages/investigation-evidence/views/cards.json';
import investigationEvidenceDashboardView from '../pages/investigation-evidence/views/dashboard.json';

/** Тип запису «Доказ» зі сторінками пакета: меню, форми та подання з pages/investigation-evidence/. */
export const investigationEvidenceDefinition: IRecordTypeDefinition = {
  ...investigationEvidenceEntity,
  views: assembleViewSet({
      table: investigationEvidenceTableView,
      cards: investigationEvidenceCardsView,
      dashboard: investigationEvidenceDashboardView,
  }),
  form: investigationEvidenceFullForm,
  forms: { full: investigationEvidenceFullForm, context: investigationEvidenceContextForm, mini: investigationEvidenceMiniForm, lookup: investigationEvidenceLookupForm },
  menu: investigationEvidenceMenu,
} as IRecordTypeDefinition;
